import { render, staticRenderFns } from "./ScanResultBox.vue?vue&type=template&id=e8140278&scoped=true"
import script from "./ScanResultBox.vue?vue&type=script&lang=js"
export * from "./ScanResultBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8140278",
  null
  
)

export default component.exports